import { useState as n, useCallback as t, useEffect as r, useRef as e } from "react";

var u = function (r) {
  var e = n(r),
      u = e[1];
  return {
    value: e[0],
    setValue: u,
    toggle: t(function () {
      return u(function (n) {
        return !n;
      });
    }, []),
    setTrue: t(function () {
      return u(!0);
    }, []),
    setFalse: t(function () {
      return u(!1);
    }, [])
  };
},
    o = function (r) {
  var e = n(r),
      u = e[1];
  return {
    value: e[0],
    setValue: u,
    add: t(function (n) {
      return u(function (t) {
        return [].concat(t, [n]);
      });
    }, []),
    clear: t(function () {
      return u(function () {
        return [];
      });
    }, []),
    removeById: t(function (n) {
      return u(function (t) {
        return t.filter(function (t) {
          return t && t.id !== n;
        });
      });
    }, []),
    removeIndex: t(function (n) {
      return u(function (t) {
        return t.filter(function (t, r) {
          return r !== n;
        });
      });
    }, [])
  };
};

function i() {
  return (i = Object.assign || function (n) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var e in r) Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }

    return n;
  }).apply(this, arguments);
}

var c = function (r, e) {
  var u = i({
    step: 1
  }, e),
      o = n(r),
      c = o[1];
  return {
    value: o[0],
    setValue: c,
    increase: t(function (n) {
      c(function (t) {
        var e = "number" == typeof n ? n : u.step,
            o = t + e;
        return void 0 !== u.upperLimit ? o - e < u.upperLimit ? o : !0 === u.loop ? r : t : o;
      });
    }, []),
    decrease: t(function (n) {
      c(function (t) {
        var r = "number" == typeof n ? n : u.step,
            e = t - r;
        return void 0 !== u.lowerLimit ? e + r > u.lowerLimit ? e : !0 === u.loop ? u.upperLimit : t : e;
      });
    }, [])
  };
},
    f = function () {
  var t = n(!1),
      r = t[1];
  return {
    focused: t[0],
    bind: {
      onFocus: function () {
        return r(!0);
      },
      onBlur: function () {
        return r(!1);
      }
    }
  };
},
    a = function () {
  var t = n(!1),
      r = t[1];
  return {
    hovered: t[0],
    bind: {
      onMouseEnter: function () {
        return r(!0);
      },
      onMouseLeave: function () {
        return r(!1);
      }
    }
  };
},
    v = function (r) {
  var e = "number" == typeof r,
      u = n(r),
      o = u[0],
      i = u[1],
      c = t(function (n) {
    return i(n.target.value);
  }, []);
  return {
    value: o,
    setValue: i,
    hasValue: null != o && (!!e || o.trim && "" !== o.trim()),
    clear: t(function () {
      return i("");
    }, []),
    onChange: c,
    bindToInput: {
      onChange: c,
      value: o
    },
    bind: {
      onChange: i,
      value: o
    }
  };
},
    l = function (n, t) {
  r(function () {
    var r = setInterval(n, t);
    return function () {
      return clearInterval(r);
    };
  });
},
    s = function (n) {
  return r(function () {
    return n.onMount && n.onMount(), function () {
      return n.onUnmount && n.onUnmount();
    };
  }, []);
},
    d = function (r) {
  var e = n(r),
      u = e[0],
      o = e[1];
  return {
    setState: t(function (n) {
      var t = i({}, u, {}, n);
      return o(t);
    }, []),
    state: u
  };
},
    p = function () {
  var t = n(navigator.onLine),
      e = t[0],
      u = t[1],
      o = function () {
    return u(!0);
  },
      i = function () {
    return u(!1);
  };

  return r(function () {
    return window.addEventListener("online", o), window.addEventListener("offline", i), function () {
      window.removeEventListener("online", o), window.removeEventListener("offline", i);
    };
  }), {
    online: e
  };
},
    m = function (n) {
  return r(function () {
    n && n();
  }, []);
},
    w = function (n) {
  return r(function () {
    return function () {
      return n && n();
    };
  }, []);
},
    L = function (n) {
  var t = e(null);
  return r(function () {
    t.current = n;
  }), t.current;
},
    b = function (n, t) {
  r(function () {
    var r = setTimeout(n, t);
    return function () {
      return clearTimeout(r);
    };
  });
};

export { o as useArray, u as useBoolean, c as useCounter, f as useFocus, a as useHover, v as useInput, l as useInterval, s as useLifecycleHooks, d as useMergeState, m as useOnMount, w as useOnUnmount, p as useOnlineStatus, L as usePrevious, b as useTimeout };